import { render, staticRenderFns } from "./ValueDialog.vue?vue&type=template&id=0660ba4f&"
import script from "./ValueDialog.vue?vue&type=script&lang=js&"
export * from "./ValueDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports